const DEFAULT_HOST_ORIGIN = 'https://www.meta-stride.com';
const API_PREFIX = '/api-v1';
const LOOPBACK_HOSTS = new Set(['127.0.0.1', 'localhost', '::1']);

const trimTrailingSlashes = (value) => value?.trim().replace(/\/+$/, '');

export const normalizeHostOrigin = (value) => {
  const normalizedValue = trimTrailingSlashes(value);

  if (!normalizedValue) {
    return DEFAULT_HOST_ORIGIN;
  }

  return normalizedValue.endsWith(API_PREFIX)
    ? normalizedValue.slice(0, -API_PREFIX.length)
    : normalizedValue;
};

const isLoopbackOrigin = (origin) => {
  try {
    return LOOPBACK_HOSTS.has(new URL(origin).hostname);
  } catch {
    return false;
  }
};

export const resolveHostOrigin = (value, nodeEnv = process.env.NODE_ENV) => {
  const origin = normalizeHostOrigin(value);

  if (nodeEnv === 'production' && isLoopbackOrigin(origin)) {
    return DEFAULT_HOST_ORIGIN;
  }

  return origin;
};

export const buildApiEndpoint = (value, nodeEnv = process.env.NODE_ENV) =>
  `${resolveHostOrigin(value, nodeEnv)}${API_PREFIX}`;

export const buildStaticUploadsEndpoint = (value, nodeEnv = process.env.NODE_ENV) =>
  `${resolveHostOrigin(value, nodeEnv)}/static/uploads`;
